import React from 'react';

const Audit = (props) =>  
<svg className={props.class} xmlns="http://www.w3.org/2000/svg" xlink="http://www.w3.org/1999/xlink" width="78.761" height="73" viewBox="0 0 78.761 73">
  <defs>
    <linearGradient id="linear-gradient" y1="0.5" x2="1" y2="0.5" gradientUnits="objectBoundingBox">
      <stop offset="0.158" stopColor="#f6760d"/>
      <stop offset="1" stopColor="#fd9400"/>
    </linearGradient>
  </defs>
  <g id="Group_13272" data-name="Group 13272" transform="translate(-1620.226 -3256.654)">
    <g id="Group_2956" data-name="Group 2956" transform="translate(-4587.849 -4525.491)">
      <path id="Path_727" data-name="Path 727" d="M6270.185,7813.444h-20.692v-10.521h20.692Zm-11.206,40h-49.192v-69.584h49.192V7801.2h-11.2v13.946h11.206v6.722h-26.145v25.922h26.145v5.651Zm26.145-7.355h-50.57v-22.5h50.57Zm-24.433-24.21v-6.721H6271.9v-13.945h-11.206v-19.066h-52.616v73h52.616V7847.8h26.145v-25.923Z" fill="url(#linear-gradient)"/>
    </g>
  </g>
</svg>

;

export default Audit;